import Dynamic from "@/lib/dynamic";
import ComponentSpinner from "@/components/ui/componentSpinner";

// ============================================================================
// DYNAMIC IMPORTS
// ============================================================================

export const ChatView = Dynamic(
  () =>
    import("./workspace/ChatView").then((mod) => ({ default: mod.ChatView })),
  { ssr: false, loading: () => <ComponentSpinner /> }
);

export const ChatBubbleLeftRightIcon = Dynamic(
  () =>
    import("@heroicons/react/24/outline").then(
      (mod) => mod.ChatBubbleLeftRightIcon
    ),
  { ssr: false, loading: () => <ComponentSpinner /> }
);
export const Cog6ToothIcon = Dynamic(
  () => import("@heroicons/react/24/outline").then((mod) => mod.Cog6ToothIcon),
  { ssr: false, loading: () => <ComponentSpinner /> }
);
export const FolderIcon = Dynamic(
  () => import("@heroicons/react/24/outline").then((mod) => mod.FolderIcon),
  { ssr: false, loading: () => <ComponentSpinner /> }
);
export const DocumentTextIcon = Dynamic(
  () =>
    import("@heroicons/react/24/outline").then((mod) => mod.DocumentTextIcon),
  { ssr: false, loading: () => <ComponentSpinner /> }
);
export const SparklesIcon = Dynamic(
  () => import("@heroicons/react/20/solid").then((mod) => mod.SparklesIcon),
  { ssr: false, loading: () => <ComponentSpinner /> }
);

export const ChangeLogTabContent = Dynamic(
  () =>
    import("./changelog/ChangeLogTimeline").then((mod) => ({
      default: mod.ChangeLogTimeline,
    })),
  { ssr: false, loading: () => <ComponentSpinner /> }
);
export const NewspaperIcon = Dynamic(
  () => import("lucide-react").then((mod) => mod.NewspaperIcon),
  { ssr: false, loading: () => <ComponentSpinner /> }
);

const ToolPanelSkeleton = () => (
  <div className="flex flex-col w-full h-full">
    <div className="flex flex-row items-center h-10 px-2 py-2 border-b border-b-black/10 dark:border-b-white/20 bg-zinc-200 dark:bg-zinc-700">
      <div className="h-4 w-24 rounded bg-gray-300 dark:bg-gray-600 animate-pulse" />
    </div>
    <div className="flex flex-row items-center gap-1 px-2 py-1 border-b border-gray-200 dark:border-gray-700">
      <div className="h-8 grow rounded bg-gray-200 dark:bg-gray-700 animate-pulse" />
    </div>
    <div className="flex flex-col gap-0">
      {Array.from({ length: 3 }).map((_, i) => (
        <div key={i} className="flex flex-row gap-2 p-2 items-center animate-pulse border-b border-white/10">
          <div className="w-8 h-8 rounded-full bg-gray-300 dark:bg-gray-600 shrink-0" />
          <div className="flex flex-col gap-1 grow">
            <div className="h-3 w-3/4 rounded bg-gray-300 dark:bg-gray-600" />
            <div className="h-2 w-1/2 rounded bg-gray-200 dark:bg-gray-700" />
          </div>
        </div>
      ))}
    </div>
  </div>
);
export const ToolPanelContent = Dynamic(
  () =>
    import("./ToolPanelContent").then((mod) => ({
      default: mod.ToolPanelContent,
    })),
  { ssr: false, loading: () => <ToolPanelSkeleton /> }
);
export const NavIconButtons = Dynamic(
  () =>
    import("./navPanels/NavIconButtons").then((mod) => ({
      default: mod.NavIconButtons,
    })),
  { ssr: false, loading: () => <ComponentSpinner /> }
);
